import { DateTime } from 'luxon'

// Tries a JS Date, an ISO date-only string, an ISO string with an explicit zone, and a SQL
// timestamp, in that order, since the raw selection can arrive in any of those shapes.
export function parseSelectedRequestDate(
  rawEventDate: Date | string | null | undefined,
  timezone: string
): DateTime | null {
  if (rawEventDate == null || rawEventDate === '') return null

  if (rawEventDate instanceof Date) {
    const parsed = DateTime.fromJSDate(rawEventDate, { zone: timezone })
    return parsed.isValid ? parsed : null
  }

  const raw = String(rawEventDate).trim()
  if (!raw) return null

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const asStoreDate = DateTime.fromISO(raw, { zone: timezone })
    return asStoreDate.isValid ? asStoreDate : null
  }

  const asIsoWithZone = DateTime.fromISO(raw, { setZone: true })
  if (asIsoWithZone.isValid) return asIsoWithZone.setZone(timezone)

  const asIsoDate = DateTime.fromISO(raw, { zone: timezone })
  if (asIsoDate.isValid) return asIsoDate

  const asSql = DateTime.fromSQL(raw, { zone: timezone })
  if (asSql.isValid) return asSql

  return null
}
